<template>
  <nav class="navbar-law">
    <router-link to="/" class="navbar-logo-link">
      <img alt="IS LAW logo" src="../../assets/logo.svg" class="navbar-logo" />
    </router-link>

    <div class="nav-right-content">
      <ul class="navbar-list desktop-nav">
        <router-link to="/about" class="nav-link">
          <li class="nav-item">{{ $t('navbar.about') }}</li>
        </router-link>
        <router-link to="/team" class="nav-link">
          <li class="nav-item">{{ $t('navbar.ourTeam') }}</li>
        </router-link>
        <router-link to="/expertise" class="nav-link">
          <li class="nav-item">{{ $t('navbar.expertise') }}</li>
        </router-link>
        <router-link to="/careers" class="nav-link">
          <li class="nav-item">{{ $t('navbar.careers') }}</li>
        </router-link>
        <router-link to="/news" class="nav-link">
          <li class="nav-item">{{ $t('navbar.news') }}</li>
        </router-link>

        <a href="https://insolvis.ro" class="nav-link" target="_blank" rel="noopener noreferrer">
          <li class="nav-item">{{ $t('navbar.insolvency') }}</li>
        </a>
        <router-link to="/contact" class="nav-link">
          <li class="nav-item">{{ $t('navbar.contact') }}</li>
        </router-link>
      </ul>

      <button class="lang-toggle-button desktop-lang" @click="toggleLanguage">
        <span :class="['lang-text', { 'active-lang': currentLanguage === 'en', 'slide-out-right': currentLanguage === 'ro' }]">Română</span>
        <span :class="['lang-text', { 'active-lang': currentLanguage === 'ro', 'slide-out-right': currentLanguage === 'en' }]">English</span>
      </button>

      <button class="hamburger-menu" @click="toggleMobileMenu" :aria-label="$t('navbar.toggleNavMenu')">
        <div :class="{ 'line-1': true, 'open': isMobileMenuOpen }"></div>
        <div :class="{ 'line-2': true, 'open': isMobileMenuOpen }"></div>
        <div :class="{ 'line-3': true, 'open': isMobileMenuOpen }"></div>
      </button>
    </div>

    <div :class="{ 'mobile-nav-overlay': true, 'open': isMobileMenuOpen }">
      <ul class="mobile-nav-list">
        <router-link to="/about" class="mobile-nav-link" @click="toggleMobileMenu">
          <li class="mobile-nav-item">{{ $t('navbar.about') }}</li>
        </router-link>
        <router-link to="/team" class="mobile-nav-link" @click="toggleMobileMenu">
          <li class="mobile-nav-item">{{ $t('navbar.ourTeam') }}</li>
        </router-link>
        <router-link to="/expertise" class="mobile-nav-link" @click="toggleMobileMenu">
          <li class="mobile-nav-item">{{ $t('navbar.expertise') }}</li>
        </router-link>
        <router-link to="/careers" class="mobile-nav-link" @click="toggleMobileMenu">
          <li class="mobile-nav-item">{{ $t('navbar.careers') }}</li>
        </router-link>
        <router-link to="/news" class="mobile-nav-link" @click="toggleMobileMenu">
          <li class="mobile-nav-item">{{ $t('navbar.news') }}</li>
        </router-link>
        <a href="https://insolvis.ro" class="mobile-nav-link" target="_blank" rel="noopener noreferrer" @click="toggleMobileMenu">
          <li class="mobile-nav-item">{{ $t('navbar.insolvency') }}</li>
        </a>
        <router-link to="/contact" class="mobile-nav-link" @click="toggleMobileMenu">
          <li class="mobile-nav-item">{{ $t('navbar.contact') }}</li>
        </router-link>
        <li class="mobile-nav-item lang-toggle-mobile" @click="toggleLanguageAndCloseMenu">
          <span :class="['lang-text-mobile', { 'active-lang-mobile': currentLanguage === 'en', 'slide-out-right-mobile': currentLanguage === 'ro' }]">Română</span>
          <span :class="['lang-text-mobile', { 'active-lang-mobile': currentLanguage === 'ro', 'slide-out-right-mobile': currentLanguage === 'en' }]">English</span>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'navbar-law',
  data() {
    return {
      isMobileMenuOpen: false,
      currentLanguage: this.$i18n ? this.$i18n.locale : 'en',
    };
  },
  methods: {
    /**
     * Toggles the visibility of the mobile menu and controls body scrolling.
     */
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
      if (this.isMobileMenuOpen) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = ''; // Re-enable scrolling
      }
    },
    /**
     * Closes the mobile menu if the screen is resized to a desktop width.
     */
    handleResize() {
      if (window.innerWidth > 1024 && this.isMobileMenuOpen) {
        this.isMobileMenuOpen = false;
        document.body.style.overflow = '';
      }
    },
    /**
     * Toggles the current language between English and Romanian and updates Vue I18n.
     */
    toggleLanguage() {
      const newLang = this.currentLanguage === 'en' ? 'ro' : 'en';
      this.currentLanguage = newLang; // Update component's data property
      if (this.$i18n) {
        this.$i18n.locale = newLang; // Update Vue I18n's locale
        // Optionally save preference to localStorage
        localStorage.setItem('user-locale', newLang);
        console.log('Language switched to:', this.$i18n.locale);
      } else {
        console.warn('Vue I18n instance not found. Language will not change globally.');
      }
    },
    /**
     * Toggles the language and also closes the mobile menu.
     */
    toggleLanguageAndCloseMenu() {
      this.toggleLanguage();
      this.toggleMobileMenu();
    }
  },
  mounted() {
    // Attach the resize event listener when the component is mounted
    window.addEventListener('resize', this.handleResize);

    // Ensure the initial language state of the component matches i18n
    // This is important if main.js loads a stored or browser locale.
    if (this.$i18n) {
      this.currentLanguage = this.$i18n.locale;
    }
  },
  beforeUnmount() {
    // Remove the resize event listener before the component is unmounted
    window.removeEventListener('resize', this.handleResize);
    // Ensure body scrolling is re-enabled if the component is unmounted
    document.body.style.overflow = '';
  },
};
</script>

<style scoped>
/* Your existing styles are good and will remain unchanged. */
/* Just ensuring they are included here for completeness */
/*
 IMPORTANT: For the 'Montserrat' font to work, you need to import it.
 Add this to your main CSS file (e.g., `main.css` or `App.vue`'s style block)
 or in your `index.html` <head> section:
 @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap');
*/

.navbar-law {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  background-color: white;
  top: 0;
  z-index: 100;
  padding: 15px 40px; /* Increased padding for more breathing room */
  
  
}

.navbar-logo-link {
  flex-shrink: 0;
}

.navbar-logo {
  width: 160px; /* Slightly adjusted width for better balance */
  height: auto; /* Maintain aspect ratio */
  display: block;
}

.nav-right-content {
  display: flex;
  align-items: center;
  gap: 40px; /* Increased gap for desktop items */
}

/* Desktop Navigation List */
.navbar-list {
  list-style: none;
  display: flex;
  gap: 30px; /* Adjusted gap between nav items */
  margin: 0;
  padding: 0;
}

.nav-link {
  text-decoration: none;
  position: relative; /* For the underline effect */
}

.nav-item {
  color: #333; /* Darker, more professional text color */

  
  font-size: 0.95rem; /* Standard nav item font size */
  cursor: pointer;
  transition: color 0.3s ease, transform 0.2s ease;
  padding: 5px 0; /* Add vertical padding for hover area */
}

.nav-link::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 0;
  height: 2px;
  background-color: #bbd55a; /* Green underline */
  transition: width 0.3s ease;
}

.nav-link:hover .nav-item {
  color: #bbd55a;
  transform: translateY(-2px); /* Subtle lift effect */
}

.nav-link:hover::after {
  width: 100%;
}

/* Language Toggle Button - Desktop */
.lang-toggle-button {
  background-color: #bbd55a;
  color: white;
  border: 1px solid #bbd55a; /* Add a subtle border */
  padding: 8px 18px; /* Adjusted padding */
  border-radius: 25px; /* More rounded, pill-shaped button */
  cursor: pointer;
 
  font-weight: 400;
  font-size: 0.85rem;
  /* Keep hover animation, remove active state transform from here */
  transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease, box-shadow 0.2s ease; /* Added box-shadow transition */
  overflow: hidden; /* Crucial for text sliding animation */
  position: relative; /* Crucial for absolute positioning of spans */
  display: inline-flex; /* Use flex to contain spans */
  justify-content: center; /* Center content horizontally */
  align-items: center; /* Center content vertically */
  width: 75px; /* Adjusted width to fit "English" / "Română" */
  height: 35px; /* Fixed height for consistency */
}

.lang-toggle-button:hover {
  background-color: #bbd55a;
  border-color: #bbd55a;
  color: #f0f0f0; /* Slightly off-white on hover */
  box-shadow: 0 0 15px rgba(187, 213, 90, 0.6); /* Soft glow on hover */
}

.lang-toggle-button:active {
  background-color: #bbd55a; /* Darken on click */
  border-color: #bbd55a;
  box-shadow: 0 0 5px rgba(187, 213, 90, 0.8); /* Stronger glow on click */
}

/* Language Text Spans within the button */
.lang-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); /* Center the text */
  opacity: 0; /* Hidden by default */
  transition: transform 0.3s ease-out, opacity 0.3s ease-out;
  white-space: nowrap; /* Prevent text wrapping */
  width: 100%; /* Ensure text takes full width for sliding */
  text-align: center; /* Center text within its span */
}

.lang-text.active-lang {
  opacity: 1; /* Visible */
  transform: translate(-50%, -50%) translateX(0); /* Active position */
}

.lang-text.slide-out-right {
  transform: translate(-50%, -50%) translateX(100%); /* Slides out to the right */
  opacity: 0;
}

/* Hamburger Menu Icon */
.hamburger-menu {
  display: none; /* Hidden by default, shown by media query */
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px; /* Smaller padding */
  z-index: 1100;
  position: relative;
  width: 35px; /* Adjusted size */
  height: 30px; /* Adjusted size */
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  visibility: hidden; /* Controls visibility via media query */
}

.hamburger-menu div {
  width: 28px; /* Adjusted line width */
  height: 2.5px; /* Thinner lines */
  background-color: #333;
  border-radius: 2px;
  transition: all 0.3s ease;
}

/* Hamburger menu animation for 'X' shape */
.hamburger-menu .line-1.open {
  transform: rotate(-45deg) translate(-5px, 6px);
}

.hamburger-menu .line-2.open {
  opacity: 0;
}

.hamburger-menu .line-3.open {
  transform: rotate(45deg) translate(-5px, -6px);
}

/* Mobile Navigation Overlay */
.mobile-nav-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.98);
  z-index: 1050;
  display: flex;
  flex-direction: column; /* Stack content vertically */
  justify-content: center;
  align-items: center;
  transform: translateX(100%);
  transition: transform 0.4s ease-in-out;
  overflow-y: auto; /* Allow scrolling if menu content is tall */
  -webkit-overflow-scrolling: touch; /* Smooth scrolling on iOS */
}

.mobile-nav-overlay.open {
  transform: translateX(0);
}

.mobile-nav-list {
  list-style: none;
  padding: 0;
  margin: 0;
  text-align: center; /* Center mobile nav items */
  width: 80%; /* Constrain width for readability */
  max-width: 300px;
}

.mobile-nav-link {
  text-decoration: none;
}

.mobile-nav-item {
  color: #333;

  font-weight: 700; /* Bolder for mobile */
  font-size: 1.6rem; /* Slightly smaller for better fit */
  padding: 12px 0; /* Adjusted padding */
  cursor: pointer;
  transition: color 0.3s ease, transform 0.2s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05); /* Subtle separator */
}

.mobile-nav-item:last-child {
  border-bottom: none; /* No border on the last item */
}

.mobile-nav-item:hover {
  color: #ffffff;
  transform: translateX(-5px); /* Slide effect on mobile hover */
}

/* Language Toggle Button - Mobile (placed inside mobile nav list) */
.lang-toggle-mobile {
  background-color: #bbd55a;
  color: white;
  border: none;
  padding: 12px 25px; /* Adjusted padding */
  margin-top: 30px; /* More space above it */
  border-radius: 25px; /* Pill shape */
  cursor: pointer;
  font-size: 1.2rem; /* Adjusted font size */
  font-weight: 700;
  text-align: center;
  display: block; /* Make it a block element to take full width */
  width: fit-content; /* Adjust width to content */
  margin-left: auto; /* Center button */
  margin-right: auto; /* Center button */
  /* Keep hover animation, remove active state transform from here */
  transition: background-color 0.3s ease, box-shadow 0.2s ease; /* Added box-shadow transition */
  overflow: hidden; /* Crucial for text sliding animation */
  position: relative; /* Crucial for absolute positioning of spans */
  height: 45px; /* Fixed height for consistency */
  display: flex; /* Use flex to contain spans */
  justify-content: center; /* Center content horizontally */
  align-items: center; /* Center content vertically */
  width: 90px; /* Adjusted width for mobile to fit "English" / "Română" */
}

.lang-toggle-mobile:hover {
  background-color: #bbd55a;
  box-shadow: 0 0 15px rgba(187, 213, 90, 0.6); /* Soft glow on hover */
}

.lang-toggle-mobile:active {
  background-color: #bbd55a; /* Darken on click */
  box-shadow: 0 0 5px rgba(187, 213, 90, 0.8); /* Stronger glow on click */
}

/* Language Text Spans within the mobile button */
.lang-text-mobile {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); /* Center the text */
  opacity: 0; /* Hidden by default */
  transition: transform 0.3s ease-out, opacity 0.3s ease-out;
  white-space: nowrap; /* Prevent text wrapping */
  width: 100%; /* Ensure text takes full width for sliding */
  text-align: center; /* Center text within its span */
}

.lang-text-mobile.active-lang-mobile {
  opacity: 1; /* Visible */
  transform: translate(-50%, -50%) translateX(0); /* Active position */
}

.lang-text-mobile.slide-out-right-mobile {
  transform: translate(-50%, -50%) translateX(100%); /* Slides out to the right */
  opacity: 0;
}


/* --- Media Queries for Responsiveness --- */

/* Tablets and smaller desktops (up to 1024px wide) */
@media (max-width: 1024px) {
  .navbar-list.desktop-nav {
    display: none;
  }

  .desktop-lang {
    display: none; /* Hide desktop language button */
  }

  .hamburger-menu {
    display: flex; /* Show hamburger */
    visibility: visible;
  }

  .nav-right-content {
    gap: 0; /* Remove gap when desktop nav is hidden */
  }

  .navbar-law {
    padding: 15px 25px; /* Adjust padding for tablets */
  }

  .navbar-logo {
    width: 140px; /* Smaller logo on tablets */
  }
}

/* Smaller Mobile screens (up to 768px wide) */
@media (max-width: 768px) {
  .navbar-law {
    padding: 12px 18px; /* Further reduced padding */
  }

  .navbar-logo {
    width: 120px; /* Smaller logo on mobile */
  }

  .hamburger-menu {
    width: 30px;
    height: 25px;
  }

  .hamburger-menu div {
    width: 25px;
    height: 2.2px;
  }

  .mobile-nav-item {
    font-size: 1.3rem; /* Further adjust mobile nav item font size */
    padding: 10px 0;
  }

  .lang-toggle-mobile {
    font-size: 1.1rem;
    padding: 10px 20px;
    margin-top: 25px;
    height: 40px; /* Adjust height for mobile button */
  }
}

/* Very Small Mobile screens (up to 480px wide) */
@media (max-width: 480px) {
  .navbar-law {
    padding: 10px 15px; /* Minimal padding */
  }

  .navbar-logo {
    width: 100px; /* Smallest logo size */
  }

  .mobile-nav-item {
    font-size: 1.1rem; /* Smallest mobile nav item font size */
    padding: 8px 0;
  }

  .lang-toggle-mobile {
    font-size: 1rem;
    padding: 8px 15px;
    margin-top: 20px;
    height: 35px; /* Adjust height for very small mobile button */
  }
}
</style>